export type ActiveStripeAccountStatus = 'onboarding' | 'restricted' | 'pending' | 'readyToUse';

const ACTIVE_STRIPE_ACCOUNT_STATUSES = new Set<ActiveStripeAccountStatus>(['onboarding', 'restricted', 'pending', 'readyToUse']);

/** Returns true for active Stripe statuses (onboarding, restricted, pending, readyToUse). Rejected accounts return false. */
export const hasActiveStripeAccount = (status: string): status is ActiveStripeAccountStatus => {
  return ACTIVE_STRIPE_ACCOUNT_STATUSES.has(status as ActiveStripeAccountStatus);
};

/**
 * Statuses where the couple is blocked AND can unblock themselves by giving Stripe more
 * information. The backend mints an Account Link for all three of `onboarding`, `restricted` and
 * `pending`, but `pending` is deliberately excluded here: it means Stripe is already reviewing
 * what it was given, so there is nothing for the couple to fill in and the link would be its own
 * dead end. `pending` keeps its existing "approval pending" treatment.
 *
 * Gate remediation CTAs on THIS, not on `status === 'restricted'`. A couple who deferred KYC and
 * never completed the hosted flow stays `onboarding` but is just as stuck, and is served by the
 * same link -- which also makes the CTA immune to `details_submitted` misclassifying the two.
 */
const REMEDIABLE_STRIPE_ACCOUNT_STATUSES = new Set<string>(['onboarding', 'restricted']);

export const canRemediateStripeAccount = (status: string | undefined | null): boolean => {
  return !!status && REMEDIABLE_STRIPE_ACCOUNT_STATUSES.has(status);
};
